import Nullstack from 'nullstack';
export default function IconPlant2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-plant-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M2 9a10 10 0 1 0 20 0"
  }), "   ", Nullstack.element("path", {
    d: "M12 19a10 10 0 0 1 10 -10"
  }), "   ", Nullstack.element("path", {
    d: "M2 9a10 10 0 0 1 10 10"
  }), "   ", Nullstack.element("path", {
    d: "M12 4a9.7 9.7 0 0 1 2.99 7.5"
  }), "   ", Nullstack.element("path", {
    d: "M9.01 11.5a9.7 9.7 0 0 1 2.99 -7.5"
  }), " ");
}